// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"7dd578c6","879":"b6a20f4c"}[chunkId] + ".chunk.js";
};